import { useLocation } from "react-router-dom";
import { splitLocalePath, withLocale, type AppLocale } from "./localePath";

/** Locale from the current URL. Unprefixed pages are treated as English. */
export function useAppLocale(): AppLocale {
  const { pathname } = useLocation();
  return splitLocalePath(pathname).locale ?? "en";
}

/** Prefix a logical path (`/login`) with the locale currently in the URL. */
export function useLocalizedPath(): (path: string) => string {
  const locale = useAppLocale();
  return (path: string) => withLocale(path, locale);
}
